import React from "react";

const GroupColorInput = (props) => {
  const {
    label = "",
    name = "",
    divClass = "input-group",
    labelClass = "",
    errorMsg,
    children,
    ...extra
  } = props;
  return (
    <li>
      <div className="menu_item_image w-100">
        <label className={labelClass}>{label}</label>
        <div className={divClass}>
          <input name={name} id={props?.id ?? name} type="color" {...extra} />
          {children ?? ""}
          {errorMsg ?? ""}
        </div>
      </div>
    </li>
  );
};

export default GroupColorInput;
